module.exports = __webpack_public_path__ + "static/media/logo-imagine_neutral-high-main.6535053b.svg";